import axiosInstance from "../Config/axiosConfig";


const getHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  const storedDeviceId = localStorage.getItem("deviceId");
  const storedUserIp = localStorage.getItem("userIp");

  return {
    Authorization: `Bearer ${accessToken}`,
    ...(storedDeviceId && { UserDevice: storedDeviceId }),
    ...(storedUserIp && { UserIPAddress: storedUserIp }),
  };
};

export const fetchPendingClasses = async (page = 1) => {
  try {
    const response = await axiosInstance.get(`/class/get-pending-publish-classes/${page}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching classes:", error);
    throw error;
  }
};

export const publishClass = async (classId) => {
  try {
    const response = await axiosInstance.post(
      "/class/publish",
      {
        class_id: classId,
        remark: "The class is completed to go live",
      },
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error publishing class:", error);
    throw error;
  }
};

export const rejectClass = async (classId) => {
  try {
    const response = await axiosInstance.post(
      "/class/reject",
      {
        class_id: classId,
        remark: "The class does not meet the requirements",
      },
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error rejecting class:", error);
    throw error;
  }
};